export default "__VITE_ASSET__Dux2RHjP__"